import { useEffect, useMemo } from 'react'
import { throttle } from 'lodash'

/**
 * Creates a throttled version of the provided async function and cancels it on unmount.
 * @param {Function} fn async function to throttle
 * @param {number} delay throttle delay in milliseconds
 * @returns throttled function reference
 */
const useThrottleFetch = (fn, delay = 2000) => {
  const throttledFn = useMemo(() => throttle(fn, delay), [fn, delay])

  useEffect(() => {
    return () => {
      throttledFn.cancel()
    }
  }, [throttledFn])

  return throttledFn
}

export default useThrottleFetch
